import type { FC } from 'react';
import styled from 'styled-components';
import { AngleBoldLeft16, AngleBoldRight16 } from '@elfsight/icons';
import { Icon } from '@elfsight/lib-icon';

type ArrowControlPositionType = 'right' | 'left';

function ArrowControl(
  IconComponent: FC,
  position: ArrowControlPositionType,
  ariaLabel: string
) {
  return function Arrow({ ...forwardingProps }) {
    return (
      <Container
        {...forwardingProps}
        aria-label={ariaLabel}
        _position={position}
      >
        <Icon component={IconComponent} fill="#fff" size={16} />
      </Container>
    );
  };
}

export const PopupControl = {
  Next: ArrowControl(AngleBoldRight16, 'right', 'Next Post'),
  Prev: ArrowControl(AngleBoldLeft16, 'left', 'Previous Post')
};

const Container = styled.button<{
  _position: ArrowControlPositionType;
}>`
  position: absolute;
  top: 50%;
  margin-top: -16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  user-select: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.6);
  }

  &:active {
    background: rgba(0, 0, 0, 0.2);
  }

  ${({ _position }) => {
    if (_position === 'right') {
      return `
        right: -40px;
      `;
    }

    return `
      left: -40px;
    `;
  }}
`;
